import React, { useEffect, useState, useRef } from "react";
import { KendoTreeTable } from "../../Kendo/kendo_treetable";
import {
  Button,
  ErrorMsg,
  InfoIcon,
  ValidateForm,
  confirmDelete,
  sessionUser,
} from "../../Util/common";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { generateGuid } from "../../Kendo/kendo_common";
import { toast } from "react-toastify";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const HomeBanner = ({ selTab }) => {
  const [error, setError] = useState({});
  const [isAddIcon, setIsAddIcons] = useState(true);
  const modalRef = useRef(null);
  const [EditVisible, setEditVisible] = useState(false);
  const fileInputRef = useRef(null);
  const [homeBannerCount, setHomeBannerCount] = useState(0);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [Loading, setLoading] = useState(false);

  const [HomeBanner, setHomeBanner] = useState({
    bannerID: 0,
    displayinID: 0,
    shortDescription: "",
    Image: "",
    OldimagePath: "",
    CategoryType: "HOME",
    SortOrder: 0,
    SavedBy: sessionUser(),
    previewUrl: "",
  });

  const [updateHomeBanner, setUpdateHomeBanner] = useState({
    bannerID: 0,
    displayinID: 0,
    shortDescription: "",
    Image: "",
    OldimagePath: "",
  });

  const [HomeBannerList, setHomeBannerList] = useState([]);
  const [Title, setTitle] = useState("");

  const Parentscolumns = [
    {
      field: "displayedInID",
      filterable: false,
      hidden: true,
    },
    {
      field: "eventName",
      title: "Displayed In",
    },
  ];

  const childColumn = [
    {
      field: "bannerId",
      hidden: true,
    },
    {
      field: "displayedInID",
      hidden: true,
    },
    {
      field: "sortOrderId",
      hidden: true,
    },
    {
      field: "categoryType",
      hidden: true,
    },
    {
      field: "shortDescription",
      title: "Short Description",
      template: function (e) {
        const maxLength = 50;
        return e.shortDescription?.length > maxLength
          ? `${e.shortDescription.substring(0, maxLength)}...`
          : e.shortDescription;
      },
      width: 200,
    },
    {
      template: function (e) {
        if (e.imagePath) {
          return `<img src="${ImageURL}${e.imagePath}" width="40px" height="40px" />`;
        }
        return "";
      },

      title: "Image",
      width: 50,
    },
    {
      field: "thumbImagePath",
      hidden: true,
    },
  ];

  useEffect(() => {
    if (selTab == 2) {
      if (modalRef.current) {
        $(modalRef.current).on("hidden.bs.modal", () => {
          clearForm();
        });
      }

      return () => {
        if (modalRef.current) {
          $(modalRef.current).off("hidden.bs.modal");
        }
      };
    }
  }, [selTab]);

  const onValidation = (name, val) => {
    setError((prevErr) => ({
      ...prevErr,
      [name]: !val || val.trim() === "",
    }));
  };

  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    setHomeBanner({
      bannerID: 0,
      displayinID: 0,
      shortDescription: "",
      imageName: "",
      OldimagePath: "",
    });
    setError({});
    setHomeBannerList([]);
    setIsAddIcons(true);
    setIsButtonVisible(true);
    setEditVisible(false);

    setTitle("");

    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const OnHomeBannerAdd = (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    let oversize = false;
    oversize = HomeBanner.Image?.size > maxSizeInBytes;

    var err = ValidateForm(e);
    if (err) {
      setError(err);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: oversize,
      }));
    } else if (!oversize) {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
      }));
      setError({ EmptyList: false });
      let temp = { ...HomeBanner, guid: generateGuid() };
      setHomeBanner(temp);
      setHomeBannerList([...HomeBannerList, HomeBanner]);
      setHomeBanner((prev) => ({
        ...prev,
        shortDescription: "",
        Image: "",
        previewUrl: "",
      }));
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      const totalCount = homeBannerCount + HomeBannerList.length + 1;
      if (totalCount >= 3) {
        setIsButtonVisible(false);
        return;
      }
      setIsButtonVisible(true);
    } else {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: true,
      }));
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (HomeBannerList.length === 0) {
      setError({ EmptyList: true });
    } else {
      setLoading(true);
      try {
        const formData = new FormData();
        HomeBannerList.forEach((banner, index) => {
          formData.append(`bannerModel[${index}].BannerId`, banner.bannerID);
          formData.append(
            `bannerModel[${index}].DisplayedInID`,
            banner.displayinID || ""
          );
          formData.append(
            `bannerModel[${index}].ShortDescription`,
            banner.shortDescription || ""
          );
          formData.append(`bannerModel[${index}].CategoryType`, "HOME" || "");
          formData.append(`bannerModel[${index}].SavedBy`, sessionUser() || "");
          if (banner.Image) {
            formData.append(`bannerModel[${index}].Image`, banner.Image);
          }
        });
        await corepost("Banner/InsertUpdateBanner", formData);

        $("#Add_HomeBanner").modal("hide");
        clearForm();
        refreshChildGrd();
      } catch (error) {
        console.error(error);
      }
    }
  };

  const onEditClick = async (e) => {
    try {
      // Fetch the banner count based on the displayedInID
      let data = await corefetch(
        `Banner/GetHomeBannerCount?displayedInId=${e.displayedInID}`
      );

      if (data && data.homeBannerCount !== undefined) {
        const bannerCount = data.homeBannerCount;
        setHomeBannerCount(bannerCount);

        if (bannerCount >= 3) {
          toast.error("Banner limit of 3 has been exceeded.");
        } else {
          const eventName = e.eventName;
          setTitle(eventName);

          // Update the HomeBanner state
          let temp = HomeBanner;
          HomeBanner.displayinID = e.displayedInID;
          setHomeBanner(temp);

          // Show the modal
          const modal = new bootstrap.Modal(
            document.getElementById("Add_HomeBanner")
          );
          modal.show();
        }
      } else {
        console.error(
          "Failed to fetch banner count or received an invalid response."
        );
      }
    } catch (error) {
      console.error("Error fetching banner count:", error);
    }
  };

  const refreshChildGrd = () => {
    $(`#reload-BannerTreetable`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };

  const handleBannerAddDeleteClick = (e) => {
    const index = HomeBannerList.findIndex((item) => item.guid == e.guid);

    if (index !== -1) {
      // Remove the item at the found index
      const temp = HomeBannerList.filter((_, i) => i != index);
      setHomeBannerList(temp);
      setIsButtonVisible(temp.length < 3);
    }
  };

  const onRowReorderChange = async (List) => {
    let bannerId = $(List.newRow).find("td").eq(0).text();
    let displayedInId = $(List.newRow).find("td").eq(1).text();
    let oldSortId = $(List.newRow).find("td").eq(2).text();
    let newSortId = $(List.oldRow).find("td").eq(2).text();
    await corefetch(
      `Banner/SortBanner?bannerId=${bannerId}&newSortId=${newSortId}&oldSortId=${oldSortId}&displayedInId=${displayedInId}&categoryType=HOME`
    );
    refreshChildGrd();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (!file) {
      // No file selected
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        ValidFile: false,
      }));
      setHomeBanner((prev) => ({
        ...prev,
        Image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      // Valid image file
      setError({ ...error, ValidFile: false });

      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        // Handle too large file
        setHomeBanner((prev) => ({
          ...prev,
          Image: file,
        }));
      } else {
        // File size is okay
        let temp = HomeBanner;
        temp.Image = file;

        const reader = new FileReader();
        reader.onloadend = () => {
          setHomeBanner((prev) => ({
            ...prev,
            previewUrl: reader.result,
          }));
        };
        reader.readAsDataURL(file);

        setHomeBanner(temp);
        document.getElementById("image-name").value = file.name;
      }

      onValidation("Image", e.target.value);
    } else {
      // Invalid file type
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setHomeBanner((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };

  const UpdatehandleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (!file) {
      // No file selected
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        ValidFile: false,
      }));
      setUpdateHomeBanner((prev) => ({
        ...prev,
        Image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      // Valid image file
      setError({ ...error, ValidFile: false });

      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        // Handle too large file
        setUpdateHomeBanner((prev) => ({
          ...prev,
          Image: file,
        }));
      } else {
        // File size is okay
        let temp = updateHomeBanner;
        temp.Image = file;

        const reader = new FileReader();
        reader.onloadend = () => {
          setUpdateHomeBanner((prev) => ({
            ...prev,
            previewUrl: reader.result,
          }));
        };
        reader.readAsDataURL(file);

        setUpdateHomeBanner(temp);
        document.getElementById("image-name").value = file.name;
      }

      onValidation("Image", e.target.value);
    } else {
      // Invalid file type
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setUpdateHomeBanner((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };

  const handleFunctionEditClick = (e) => {
    setUpdateHomeBanner({
      bannerID: e.child.bannerId,
      displayinID: e.child.displayedInID,
      shortDescription: e.child.shortDescription,
      Image: e.child.imagePath,
      OldimagePath: e.child.imagePath,
      ThumbImagePath: e.child.thumbImagePath,
    });
    setEditVisible(true);
    setIsAddIcons(false);
    $("#update_HomeBanner").modal("show");
  };

  const onUpdate = async (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    let oversize = false;
    oversize = updateHomeBanner.Image?.size > maxSizeInBytes;

    var err = ValidateForm(e);
    if (err) {
      setError(err);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: oversize,
      }));
    } else if (!oversize) {
      setLoading(true);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
      }));
      try {
        const formData = new FormData();
        const banners = [updateHomeBanner];

        banners.forEach((banner, index) => {
          formData.append(`[${index}].BannerId`, banner.bannerID);
          formData.append(`[${index}].DisplayedInID`, banner.displayinID);
          formData.append(
            `[${index}].ShortDescription`,
            banner.shortDescription
          );
          formData.append(`[${index}].CategoryType`, "HOME");
          formData.append(`[${index}].SavedBy`, sessionUser());
          formData.append(`[${index}].OldImagePath`, banner.OldimagePath);
          formData.append(`[${index}].ThumbImagePath`, banner.ThumbImagePath);

          if (banner.Image) {
            formData.append(`[${index}].Image`, banner.Image);
          }
        });
        await corepost("Banner/InsertUpdateBanner", formData);

        $("#update_HomeBanner").modal("hide");
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.value = null;
        }
        clearForm();
        refreshChildGrd();
      } catch (error) {
        console.error(error);
      }
    } else {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: true,
      }));
    }
  };

  const handleDeleteClick = async (e) => {
    const onDelete = async () => {
      let SavedBy = sessionUser();
      await corefetch(
        `Banner/DeleteBanner?id=${e.bannerId}&DeletedBy=${SavedBy}`,
        true,
        false,
        true
      );
      refreshChildGrd();
    };
    confirmDelete(onDelete);
  };

  return (
    <div className="col-auto ms-auto">
      <KendoTreeTable
        name={"BannerTreetable"}
        parentTableUrl={CorebaseURL + "Banner/GetHomeBannerList"}
        parentTableColumns={Parentscolumns}
        childTableUrl={
          CorebaseURL +
          "Banner/GetBannerDetailsByID?displayedinID={displayedInID}&CategoryType=HOME"
        }
        childTableColumns={childColumn}
        onParentEditClick={onEditClick}
        showParentOptions={true}
        showParentDelete={false}
        showChildOptions={true}
        showChildDelete={true}
        onChildEditClick={handleFunctionEditClick}
        onChildDeleteClick={handleDeleteClick}
        refreshWhen={HomeBannerList.length}
        enableRowReorderable={true}
        onRowReorder={onRowReorderChange}
        parentpaggable={false}
        noteLabel="Note:"
        noteContent="This module supports drag-and-drop functionality, you can easily
                rearrange or move data as needed."
      />

      {/* Add HomeBanner Modal */}
      <div
        className="modal custom-modal fade"
        id="Add_HomeBanner"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={{ width: "900px" }}
        >
          <div className="modal-content">
            <div className="modal-header d-flex justify-content-between align-items-center">
              <h5 className="modal-title">{Title}-Add</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={clearForm}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="subfun-form" onSubmit={OnHomeBannerAdd}>
                <input
                  type="hidden"
                  name="bannerID"
                  value={HomeBanner.bannerID || 0}
                />
                <input
                  type="hidden"
                  name="displayinID"
                  value={HomeBanner.displayinID || 0}
                />
                <input
                  type="hidden"
                  name="CategoryType"
                  value={HomeBanner.CategoryType || 0}
                />
                <div className="row input-block mb-3">
                  <div className="col-md-12">
                    <label className="form-label">
                      Short Description <span className="text-danger">*</span>
                      <InfoIcon content="Please provide a description with a maximum length of 200 characters." />
                    </label>
                    <textarea
                      type="text"
                      maxLength={200}
                      className="form-control field"
                      name="ShortDescription"
                      value={HomeBanner.shortDescription || ""}
                      placeholder="Short Description"
                      data-required="true"
                      onChange={(e) => {
                        setHomeBanner((prev) => ({
                          ...prev,
                          shortDescription: e.target.value,
                        }));
                        onValidation("ShortDescription", e.target.value);
                      }}
                    />

                    {error.ShortDescription && (
                      <ErrorMsg text="Short Description is required" />
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-10">
                    <label className="form-label">
                      Home Banner Image <span className="text-danger">*</span>
                      <InfoIcon
                        content="Kindly upload an Image within 500KB size;
                      Please upload the image in JPEG, JPG or PNG format."
                      />
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      ref={fileInputRef}
                      name="file"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    {error.Image && (
                      <ErrorMsg text="Home Banner Image is required" />
                    )}
                    {error.ValidFile && (
                      <ErrorMsg text="please upload Image file only" />
                    )}
                    {error.EmptyList && (
                      <ErrorMsg text={"Please add at least one Banner"} />
                    )}
                    {error.InValidFileSize && (
                      <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                    )}
                  </div>
                  <div className="col-md-2">
                    {isButtonVisible && ( // Only show the button if `isButtonVisible` is true
                      <button
                        type="submit"
                        className="btn btn-primary"
                        style={{ marginTop: "22px" }}
                        title="Add Banner"
                      >
                        <i
                          className={
                            isAddIcon
                              ? "las la-plus-circle"
                              : "las la-check-circle"
                          }
                        ></i>
                      </button>
                    )}
                  </div>

                  <div className="row mt-1 mb-3">
                    {HomeBanner.OldimagePath && HomeBanner.bannerID > 0 && (
                      <div
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <a
                          href={`${ImageURL}${HomeBanner.OldimagePath}`}
                          target="_blank"
                          style={{
                            textDecoration: "underline",
                            fontSize: "13px",
                          }}
                        >
                          {HomeBanner.OldimagePath.split("/").pop()}
                        </a>
                      </div>
                    )}
                    <input
                      type="hidden"
                      name="Image"
                      id="image-name"
                      data-required="true"
                      value={HomeBanner.Image || ""}
                    />
                    <input
                      type="hidden"
                      name="OldimagePath"
                      value={HomeBanner.OldimagePath}
                    />
                  </div>
                </div>
              </form>

              <form id="subgrid-form" onSubmit={onSubmit}>
                <span className="k-form-error k-invalid-msg">
                  (Note: Only the items added to the grid will be saved.)
                </span>
                {/* {HomeBannerList.length > 0 && ( */}
                <KendoGrid
                  name={"homeBannerSubGrid"}
                  disableToolbar={true}
                  paggable={false}
                  data={HomeBannerList}
                  columns={[
                    {
                      field: "guid",
                      hidden: true,
                    },
                    {
                      field: "primaryId",
                      hidden: true,
                    },
                    {
                      field: "displayinID",
                      hidden: true,
                    },
                    {
                      field: "category",
                      hidden: true,
                    },
                    {
                      field: "savedBy",
                      hidden: true,
                    },
                    {
                      field: "shortDescription",
                      title: "Short Description",
                      template: function (e) {
                        const maxLength = 40; // Set max length for display
                        return e.shortDescription.length > maxLength
                          ? `${e.shortDescription.substring(0, maxLength)}...`
                          : e.shortDescription;
                      },
                    },
                    {
                      field: "previewUrl",
                      title: "Uploaded Image",
                      template: (dataItem) =>
                        dataItem.previewUrl
                          ? `<div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                <img
                                  src="${dataItem.previewUrl}"
                                  alt="Uploaded Preview"
                                  style="width: auto; height: 40px; object-fit: cover;"
                                />
                              </div>`
                          : `<div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                No Image
                              </div>`,
                    },
                  ]}
                  showOptions={true}
                  showDelete={true}
                  showEdit={false}
                  onDeleteClick={(e) => handleBannerAddDeleteClick(e)}
                  refreshWhen={HomeBannerList.length}
                />
                {/* )} */}
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end btn-mt">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      dataBsDismiss={"modal"}
                      onClick={clearForm}
                    />
                    <Button name={"Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Update Home Banner Modal --> */}
      <div
        className="modal custom-modal fade"
        id="update_HomeBanner"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={clearForm}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="subUpdateHBanner-form" onSubmit={onUpdate}>
                <div className="row">
                  <input
                    type="hidden"
                    name="bannerID"
                    value={updateHomeBanner.bannerID}
                  />
                  <input
                    type="hidden"
                    name="displayinID"
                    value={updateHomeBanner.displayinID}
                  />
                  <div className="row input-block mb-3">
                    <div className="col-md-12">
                      <label className="form-label">
                        Short Description <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a description with a maximum length of 200 characters." />
                      </label>
                      <textarea
                        type="text"
                        maxLength={200}
                        className="form-control field"
                        name="ShortDescription"
                        value={updateHomeBanner.shortDescription || ""}
                        placeholder="Short Description"
                        data-required="true"
                        onChange={(e) => {
                          setUpdateHomeBanner((prev) => ({
                            ...prev,
                            shortDescription: e.target.value,
                          }));
                          onValidation("ShortDescription", e.target.value);
                        }}
                      />

                      {error.ShortDescription && (
                        <ErrorMsg text="Short Description is required" />
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-10">
                      <label className="form-label">
                        Home Banner Image <span className="text-danger">*</span>
                        <InfoIcon
                          content="Kindly upload an Image within 500KB size;
                        Please upload the image in JPEG, JPG or PNG format."
                        />
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        ref={fileInputRef}
                        name="file"
                        accept="image/*"
                        onChange={UpdatehandleFileChange}
                      />
                      {error.Image && (
                        <ErrorMsg text="Home Banner Image is required" />
                      )}
                      {error.ValidFile && (
                        <ErrorMsg text="please upload Image file only" />
                      )}
                      {error.InValidFileSize && (
                        <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                      )}
                    </div>
                    <div className="row mt-1 mb-3">
                      {updateHomeBanner.OldimagePath &&
                        updateHomeBanner.bannerID > 0 && (
                          <div
                            style={{
                              width: "100%",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <a
                              href={`${ImageURL}${updateHomeBanner.OldimagePath}`}
                              target="_blank"
                              style={{
                                textDecoration: "underline",
                                fontSize: "13px",
                              }}
                            >
                              {updateHomeBanner.OldimagePath.split("/").pop()}
                            </a>
                          </div>
                        )}
                      <input
                        type="hidden"
                        name="Image"
                        id="image-name"
                        data-required="true"
                        value={updateHomeBanner.Image || ""}
                      />
                      <input
                        type="hidden"
                        name="OldimagePath"
                        value={updateHomeBanner.OldimagePath}
                      />
                    </div>
                  </div>
                  {Loading ? (
                    <KendoLoader className="d-flex justify-content-end align-items-center" />
                  ) : (
                    <div className="text-end btn-mt">
                      <Button
                        name={"Cancel"}
                        isCancelButton={true}
                        id="ballroom-ballfun-cancel"
                        dataBsDismiss={"modal"}
                        onClick={() => {
                          clearForm();
                        }}
                      />
                      <Button name={"Update"} />
                    </div>
                  )}
                  <button
                    type="button"
                    id="hide"
                    style={{ display: "none" }}
                    data-bs-dismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  ></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Update Home Banner Modal --> */}
    </div>
  );
};
